import '../../components/Loader/loader.less'
import { fetchToken, setAuth, Token_Params } from '../login/loginSlice'
import { RootState } from '../../rootReducer'
import { accessTokenKey } from '../../constants'
import { getRedirectionPath, goToLoginPage } from '../../utils/urlUtil'
import { STATES } from '../../interfaces'
import historyService from '../../services/historyService'
import LoaderView from '../../components/Loader/loader'
import { connect } from 'react-redux'
import React, { useEffect } from 'react'

interface IProps {
  fetchingAuthStatusState?: STATES
  isAuthenticated: boolean
  fetchToken: (params: Token_Params) => void
  setAuth: (param: boolean) => void
}

const Loading = ({
  fetchingAuthStatusState,
  isAuthenticated,
  fetchToken,
  setAuth
}: IProps): React.ReactElement => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  const sessionState = urlSearchParams.get('session_state')
  const code = urlSearchParams.get('code')
  const resetUrlQueryStr = true

  const redirectTo = getRedirectionPath()

  useEffect(() => {
    const session = window.localStorage.getItem(accessTokenKey)
    if ((sessionState && code) || isAuthenticated || session) {
      if (isAuthenticated || (session && session !== 'undefined')) {
        setAuth(true)
        historyService.push(redirectTo)
      } else {
        if (fetchingAuthStatusState == STATES.failed) {
          setTimeout(() => goToLoginPage(), 500)
        } else {
          if (fetchingAuthStatusState !== STATES.pending && sessionState && code)
            fetchToken({
              session_state: sessionState,
              code,
              redirectURI: `${window.location.origin}`
            })
        }
      }
    } else {
      goToLoginPage()
    }
  }, [
    isAuthenticated,
    redirectTo,
    fetchingAuthStatusState,
    fetchToken,
    resetUrlQueryStr,
    code,
    sessionState,
    setAuth
  ])

  if (fetchingAuthStatusState == STATES.pending) {
    return <LoaderView showLoader />
  } else {
    return <></>
  }
}

const mapDispatchToProps = {
  fetchToken,
  setAuth
}

const mapStateToProps = (state: RootState) => ({
  fetchingAuthStatusState: state.user.fetchingAuthStatusState,
  isAuthenticated: state.user.isAuthenticated
})

export default connect(mapStateToProps, mapDispatchToProps)(Loading)
